import clsxm from "@/lib/clsxm";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const OptionalChip: FC<{className?: string; isLight?: boolean; isSmall?: boolean}> = ({
  className,
  isLight,
  isSmall,
}) => {
  const {t} = useTranslation("common");

  return (
    <span
      className={clsxm(
        "text-neutral-black bg-neutral-white-dark text-2xs flex min-h-5 w-fit items-center justify-center rounded-full px-2 font-semibold uppercase",
        isLight && "border-primary-light-solid text-neutral-grey-dark border bg-white",
        isSmall && "text-3xs h-4 min-h-4 px-1 font-medium capitalize",
        className,
      )}>
      {t("optional")}
    </span>
  );
};

export default OptionalChip;
